import AudienceDetails from "./AudienceDetails";

export default AudienceDetails;
